
import {Vue, Component} from 'vue-property-decorator';
import DatePicker from '../../../../modules/@appbase/components/DatePicker/DatePicker.vue';
import * as dateutil from '../../../../modules/@appbase/util/date-helper'
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5percent from "@amcharts/amcharts5/percent";
import api from '@reserve/api';
import {object} from "@amcharts/amcharts5";
import { mapGetters } from 'vuex';
import * as types from '@account/store/types';

import axios from 'axios';
import { IEDate, invalidateUrl, uGetDate, uGetDateFormat, uGetDateOnly } from '@appbase/util';
type DataItem = {
    day: string;
    value: number;
    bullet?: boolean; // bullet 속성을 추가
};

type RangeItem = {
    date: string;
    value: number;
    bullet?: boolean; // bullet 속성을 추가
};

type DonutItem={
    category: string,
    value: number,
    percentile : string,
    settings: object
}
type NoShowItem={
    label : string;
    value : number;
    noShowCnt : number;
    percentile : string;
    valueStr : string;
}


@Component({
    components: {
        DatePicker,
    },
    computed: {
        ...mapGetters({
            user: types.USER,
        }),
    },

})

export default class ReserveDashboard extends Vue {
    user!: account.TUser;
    private daysLineChart: am5.Root | null = null;
    private rangeLineChart: am5.Root | null = null;
    private donutChart: am5.Root | null = null;

    // 부모 미팅룸 리스트
    parentMeetingroomList : meetingroom.parentRoom[]  = [];


    //엑셀 다운로드 : 기간
    startDate: string = dateutil.uGetDateFormat('yyyy-MM-DD', new Date(new Date().setDate(new Date().getDate() - 30)));
    endDate: string = dateutil.uGetDateFormat('yyyy-MM-DD', new Date());
    parentCnfroomId : string = '';
    // 현황
    TotCnt : string = '';
    DiffCnt : string = '';
    UdClass : string = '';
    TotCnt_ENTER : string = '';
    TotCnt_CANCEL : string = '';
    AvgReserveMim : number = 0;
    RoomOperatingRate : string = '';
    NoShowPercentile : string = '';

    //날짜(년.월) 값
    currentYear: number = new Date().getFullYear();
    currentMonth: number = new Date().getMonth() + 1;
    formattedMonth: string = this.currentMonth.toString().padStart(2, '0');
    StYm: string = `${this.currentYear.toString()}-${this.formattedMonth}`;

    // 요일별 그래프
    daysTotCnt : string = '0';
    // 본부별 그래플
    deptTotCnt : string = '0';


    //라인 그래프: 기간별 사용분석
    rangeBtn: string[] = ['7일', '15일', '한달', '1년'];
    selectedRange: string = '15일';

    //막대 그래프: 본부별 미사용 width animation
    noShowBars: number[] = [];
    noShowData: NoShowItem[] = [];
    // 차트용 회사 구분
    statParentCnfroomId : string = '';
    // 차트 개별 구분자
    daysLineGraphDt: string = ''; // 요일별 분석 라인
    rangeLineGraphRange: string = ''; // 기간별 분석 라인
    reserveDonutDt: string = ''; // 본부별 예약 도넛 그래프 그리기
    barGraphAnimatedDt: string = ''; // 본부별 미사용 막대 그래프


    mounted() {
        this.updateDatePickers(); // 엑셀 다운로드 기간
        this.getParentConferenceRoom(); // 부모 미팅룸 리스트 가져오기

        this.$nextTick(() => {

            this.daysLineGraphDt= '1'; // 요일별 분석 라인
            this.rangeLineGraphRange= '15일'; // 기간별 분석 라인
            this.reserveDonutDt= '1'; // 본부별 예약 도넛 그래프 그리기
            this.barGraphAnimatedDt= '1'; // 본부별 미사용 막대 그래프


            this.updateStatus();        // 통계 현황
            this.daysLineGraph(); // 요일별 분석 라인 그래프
            this.rangeLineGraph(); // 기간별 분석 라인 그래프
            this.reserveDonut(); // 본부별 예약 도넛 그래프 그리기
            this.barGraphAnimated(); // 본부별 미사용 막대 그래프
        });
    }

      changeChart(){
          this.updateStatus();     //통계 현황
    }

    //부모 회의실 변경시 차트 변경
    statParentCnfroom(){
        this.updateStatus();        // 통계 현황
        this.daysLineGraph; // 요일별 분석 라인 그래프
        this.rangeLineGraph(); // 기간별 분석 라인 그래프
        this.reserveDonut(); // 본부별 예약 도넛 그래프 그리기
        this.barGraphAnimated(); // 본부별 미사용 막대 그래프
    }


    updateDateRange(event: Event) {
        const months = parseInt((event.target as HTMLSelectElement).value);
        const endDate = new Date();
        const startDate = new Date(new Date().setMonth(endDate.getMonth() - months));

        this.startDate = dateutil.uGetDateFormat('yyyy-MM-DD', startDate);
        this.endDate = dateutil.uGetDateFormat('yyyy-MM-DD', endDate);
        this.updateDatePickers();
    }

    //차트별 n개월 select change 이벤트
    updateDateDays(event: Event){
        // this.daysLineGraph(event.target.value); // 요일별 분석 라인 그래프
        const target = event.target as HTMLSelectElement;
        this.daysLineGraphDt = target.value;
        this.daysLineGraph();
    }
    updateDateReserve(event: Event){

        const target = event.target as HTMLSelectElement;
        this.reserveDonutDt = target.value;
        this.reserveDonut(); // 요일별 분석 라인 그래프
    }
    updateDateNoShow(event: Event){
        const target = event.target as HTMLSelectElement;
        this.barGraphAnimatedDt = target.value;
        this.barGraphAnimated(); // 요일별 분석 라인 그래프
    }

    updateStartDate(date: Date) {
        this.startDate = dateutil.uGetDateFormat('yyyy-MM-DD', date);

        if (new Date(this.startDate) > new Date(this.endDate)) {
            this.endDate = this.startDate;
        }
        this.updateDatePickers();
    }

    updateEndDate(date: Date) {
        this.endDate = dateutil.uGetDateFormat('yyyy-MM-DD', date);

        if (new Date(this.endDate) < new Date(this.startDate)) {
            this.startDate = this.endDate;
        }
        this.updateDatePickers();
    }

    updateDatePickers() {
        const startPicker = this.$refs.startPicker as any;
        const endPicker = this.$refs.endPicker as any;

        if (startPicker) {
            startPicker.baseValue = this.startDate;
            startPicker.renderPicker();
        }

        if (endPicker) {
            endPicker.baseValue = this.endDate;
            endPicker.renderPicker();
        }
    }


    //현황데이터 조회
    async updateStatus(){
        let  LyStYm:string =`${(this.currentYear-1).toString()}-${this.formattedMonth}`;

        let statusApiData: meetingroom.meetingroomStatData =
            await api.meetingroom.getConferenceRoomReserveStatusData(this.StYm,LyStYm,this.statParentCnfroomId).
            then((res) => {return res;});

        // 이달 누적 사용
        this.TotCnt = this.formatNumber(statusApiData.totCnt);
        // 작년 동기대비
        this.DiffCnt =   this.formatNumber(Math.abs(statusApiData.totCnt - statusApiData.lyTotCnt));

        // 작년 동기대비 icon
        this.UdClass = statusApiData.totCnt - statusApiData.lyTotCnt > 0 ? 'ico_up' :
                    statusApiData.totCnt - statusApiData.lyTotCnt < 0 ? 'ico_dow':'';
        // 예약 사용
        this.TotCnt_ENTER =  this.formatNumber(statusApiData.totCnt_ENTER);
        // 예약 미사용
        this.TotCnt_CANCEL =  this.formatNumber(statusApiData.totCnt_CANCEL);
        // 회의실 가동률
        this.RoomOperatingRate = statusApiData.roomOperatingRate;
        // 평균 회의 진행 시간
        this.AvgReserveMim = statusApiData.avgReserveMim;
        // 노쇼발생율
        this.NoShowPercentile = statusApiData.noShowPercentile;

    }


    goToPreviousMonth() {
        if (this.currentMonth === 1) {
            this.currentMonth = 12;
            this.currentYear -= 1;
        } else {
            this.currentMonth -= 1;
        }
        this.formattedMonth = this.currentMonth.toString().padStart(2, '0');
        this.StYm = `${this.currentYear.toString()}-${this.formattedMonth}`;

        this.changeChart();
    }

    goToNextMonth() {
        if (this.currentMonth === 12) {
            this.currentMonth = 1;
            this.currentYear += 1;
        } else {
            this.currentMonth += 1;
        }
        this.formattedMonth = this.currentMonth.toString().padStart(2, '0');
        this.StYm = `${this.currentYear.toString()}-${this.formattedMonth}`;
        this.changeChart();
    }

    // amChart


    //라인 그래프: 요일별 사용분석
    async daysLineGraph() {
        if (this.daysLineChart) {
            this.daysLineChart.dispose();
        }

        this.daysLineChart = am5.Root.new("dayLineGraph");

        // if (this.daysLineChart._logo) {
        //     (this.daysLineChart._logo as any).dispose();
        // }

        this.daysLineChart.setThemes([
            am5themes_Animated.new(this.daysLineChart)
        ]);

        let chart = this.daysLineChart.container.children.push(
            am5xy.XYChart.new(this.daysLineChart, {
                panX: false,
                panY: false,
                wheelY: "none",
                layout: this.daysLineChart.verticalLayout
            })
        );

        // API 호출 및 데이터 처리
        let data: DataItem[] = await this.getWeekDayData();

        // Craete Y-axis
        let yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(this.daysLineChart, {
                renderer: am5xy.AxisRendererY.new(this.daysLineChart, {
                    minGridDistance: 40,
                }),
                min: 0,
                // max: 200,
                strictMinMax : false,       // Y축 자동 조절
                extraMax: 0.2
            })
        );

        // Create X-Axis
        let xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(this.daysLineChart, {
                renderer: am5xy.AxisRendererX.new(this.daysLineChart, {
                    minGridDistance: 50,
                }),
                categoryField: "day",
                startLocation: 0.3,
                endLocation: 0.7,

            })
        );

        xAxis.data.setAll(data);

        let xRenderer = xAxis.get("renderer");
        xRenderer.grid.template.setAll({
            stroke: am5.color(0xDAE3EB),
            strokeWidth: 0,
            strokeOpacity: 0,
        });
        xRenderer.labels.template.setAll({
            fill: am5.color(0x6A7075),
            fontSize: "10px",
            paddingTop: 20,
        });

        let yRenderer = yAxis.get("renderer");
        yRenderer.grid.template.setAll({
            stroke: am5.color(0xDAE3EB),
            strokeWidth: 1,
            strokeOpacity: 1,
        });
        yRenderer.labels.template.setAll({
            fill: am5.color(0x6A7075),
            fontSize: "10px"
        });

        // Create series
        let series = chart.series.push(
            am5xy.LineSeries.new(this.daysLineChart, {
                name: 'line',
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: 'value',
                categoryXField: "day",
                stroke: am5.color(0x852EDF),
                fill: am5.color(0x852EDF),
                stacked: true,
            })
        );

        data[data.length - 1].bullet = true;

        series.fills.template.set("fillGradient", am5.LinearGradient.new(this.daysLineChart, {
            stops: [{
                opacity: 0.7,
                color: am5.color(0xC091ED)
            }, {
                opacity: 0,
                color: am5.color(0xC091ED)
            }],
            rotation: 90
        }));

        series.fills.template.setAll({
            visible: true,
            fillOpacity: 1
        });

        series.strokes.template.setAll({
            strokeWidth: 1
        });

        series.bullets.push(function (daysLineChart, series, dataItem) {
            // Bullet container
            var container = am5.Container.new(daysLineChart, {
                rotation: 0
            });

            var labelNumber = container.children.push(am5.Container.new(daysLineChart, {
                centerX: am5.p50,
                centerY: am5.p100,
                dy: -5,
                width: 40,
                height: 40,
                background: am5.RoundedRectangle.new(daysLineChart, {
                    fill: am5.color(0xffffff),
                    fillOpacity: 0,
                    cornerRadiusTL: 20,
                    cornerRadiusTR: 20,
                    cornerRadiusBR: 20,
                    cornerRadiusBL: 20,
                })
            }));

            // Label
            labelNumber.children.push(am5.Label.new(daysLineChart, {
                text: "{valueY}",
                oversizedBehavior: "wrap",
                maxWidth: 40,
                fontSize: 12,
                fontWeight: "bold",
                x: am5.p50,
                centerX: am5.p50,
                y: am5.p50,
                centerY: am5.p50,
                paddingTop: 0,
                paddingRight: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                populateText: true
            }));

            // Circle
            container.children.push(am5.Circle.new(daysLineChart, {
                radius: 3,
                stroke: am5.color(0x852EDF),
                strokeWidth: 2,
                fill: am5.color(0xffffff),
            }));

            return am5.Bullet.new(daysLineChart, {
                sprite: container
            })
        });


        // Add cursor
        let cursor = chart.set("cursor", am5xy.XYCursor.new(this.daysLineChart, {
            xAxis: xAxis
        }));
        cursor.lineY.set("visible", false);

        //tooltip
        let tooltip = am5.Tooltip.new(this.daysLineChart, {
        });

        let background = tooltip.get("background");
        if (background) {
            background.setAll({
                stroke: am5.color(0x852EDF),
                strokeOpacity: 1
            });
        }

        series.data.setAll(data);
    }


    makeChart(range: string) {
        if (this.rangeLineChart) {
            this.selectedRange = range;
            this.rangeLineGraphRange = range;
            this.rangeLineChart.dispose();
            this.rangeLineGraph();
        }
    }


    async  rangeLineGraph() {
        if (this.rangeLineChart) {
            this.rangeLineChart.dispose();
        }

        this.rangeLineChart = am5.Root.new("rangeLineChart");
        // if (this.rangeLineChart._logo) {
        //     (this.rangeLineChart._logo as any).dispose();
        // }

        this.rangeLineChart.setThemes([
            am5themes_Animated.new(this.rangeLineChart)
        ]);

        let chart = this.rangeLineChart.container.children.push(
            am5xy.XYChart.new(this.rangeLineChart, {
                panX: false,
                panY: false,
                wheelY: "none",
                layout: this.rangeLineChart.verticalLayout
            })
        );

        // Define data
        let data: RangeItem[] = await this.getPeriodData(this.rangeLineGraphRange);
        // Craete Y-axis
        let yAxis = chart.yAxes.push(
            am5xy.ValueAxis.new(this.rangeLineChart, {
                renderer: am5xy.AxisRendererY.new(this.rangeLineChart, {
                    minGridDistance: 30,
                }),
                min: 0,
                // max: 500,
                strictMinMax : false,       // Y축 자동 조절
                extraMax: 0.2
            })
        );

        // Create X-Axis
        let xAxis = chart.xAxes.push(
            am5xy.CategoryAxis.new(this.rangeLineChart, {
                renderer: am5xy.AxisRendererX.new(this.rangeLineChart, {
                    minGridDistance: 50,
                }),
                categoryField: "date",
                startLocation: 0.3,
                endLocation: 0.7,
            })
        );
        xAxis.data.setAll(data);

        let xRenderer = xAxis.get("renderer");
        xRenderer.grid.template.setAll({
            stroke: am5.color(0xDAE3EB),
            strokeWidth: 0,
            strokeOpacity: 0,
        });
        xRenderer.labels.template.setAll({
            fill: am5.color(0x6A7075),
            fontSize: "10px",
            paddingTop: 20,
        });

        let yRenderer = yAxis.get("renderer");
        yRenderer.grid.template.setAll({
            stroke: am5.color(0xDAE3EB),
            strokeWidth: 1,
            strokeOpacity: 1,
        });
        yRenderer.labels.template.setAll({
            fill: am5.color(0x6A7075),
            fontSize: "10px"
        });

        // Create series
        let series = chart.series.push(
            am5xy.LineSeries.new(this.rangeLineChart, {
                name: 'line',
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: 'value',
                categoryXField: "date",
                stroke: am5.color(0x6666FF),
                fill: am5.color(0x6666FF),
                stacked: true,
            })
        );

        data[data.length - 1].bullet = true;

        series.fills.template.set("fillGradient", am5.LinearGradient.new(this.rangeLineChart, {
            stops: [{
                opacity: 0.7,
                color: am5.color(0xA5AAF2)
            }, {
                opacity: 0,
                color: am5.color(0xA5AAF2)
            }],
            rotation: 90
        }));

        series.fills.template.setAll({
            visible: true,
            fillOpacity: 1
        });

        series.strokes.template.setAll({
            strokeWidth: 1
        });

        series.bullets.push(function (rangeLineChart, series, dataItem) {
            // Bullet container
            var container = am5.Container.new(rangeLineChart, {
                rotation: 0
            });

            var labelNumber = container.children.push(am5.Container.new(rangeLineChart, {
                centerX: am5.p50,
                centerY: am5.p100,
                dy: -5,
                width: 40,
                height: 40,
                background: am5.RoundedRectangle.new(rangeLineChart, {
                    fill: am5.color(0xffffff),
                    fillOpacity: 0,
                    cornerRadiusTL: 20,
                    cornerRadiusTR: 20,
                    cornerRadiusBR: 20,
                    cornerRadiusBL: 20,
                })
            }));

            // Label
            labelNumber.children.push(am5.Label.new(rangeLineChart, {
                text: "{valueY}",
                oversizedBehavior: "wrap",
                maxWidth: 40,
                fontSize: 12,
                fontWeight: "bold",
                x: am5.p50,
                centerX: am5.p50,
                y: am5.p50,
                centerY: am5.p50,
                paddingTop: 0,
                paddingRight: 0,
                paddingBottom: 0,
                paddingLeft: 0,
                populateText: true
            }));

            // Circle
            container.children.push(am5.Circle.new(rangeLineChart, {
                radius: 3,
                stroke: am5.color(0x6666FF),
                strokeWidth: 2,
                fill: am5.color(0xffffff),
            }));

            return am5.Bullet.new(rangeLineChart, {
                sprite: container
            })
        });

        // Add cursor
        let cursor = chart.set("cursor", am5xy.XYCursor.new(this.rangeLineChart, {
            xAxis: xAxis
        }));
        cursor.lineY.set("visible", false);

        //tooltip
        let tooltip = am5.Tooltip.new(this.rangeLineChart, {
        });

        let background = tooltip.get("background");
        if (background) {
            background.setAll({
                stroke: am5.color(0x6666FF),
                strokeOpacity: 1
            });
        }

        series.data.setAll(data);
    }

    //도넛 그래프: 본부별 예약 이용 현황
    async reserveDonut() {
        if (this.donutChart) {
            this.donutChart.dispose();
        }

        this.donutChart = am5.Root.new("reserveDonut");
        let donutRoot = this.donutChart;

        donutRoot.setThemes([
            am5themes_Animated.new(donutRoot)
        ]);

        // if (donutRoot._logo) {
        //     (donutRoot._logo as any).dispose();
        // }

        // Create chart
        let chart = donutRoot.container.children.push(am5percent.PieChart.new(donutRoot, {
            radius: am5.percent(90),
            innerRadius: am5.percent(60),
            layout: donutRoot.horizontalLayout
        }));

        // Create series
        let series = chart.series.push(am5percent.PieSeries.new(donutRoot, {
            categoryField: "category",
            valueField: "value",
            legendLabelText: "[0x6A7075]{category}[/]",
            legendValueText: "[bold]{value}[/]건",
            alignLabels: false,
            /*tooltip: am5.Tooltip.new(donutRoot, {
                pointerOrientation: "vertical",
                labelText: "{value}건"
            }),*/
        }));

        // Disabling labels and ticks
        //series.labels.template.set("visible", false);
        series.slices.template.set("tooltipText", "");
        series.ticks.template.set("visible", false);

        series.labels.template.setAll({
            fontSize: 12,
            text: "[bold]{valuePercentTotal.formatNumber('0.')}%",
            textType: "aligned",
            radius: -40,
            fill: am5.color(0xffffff),
        })

        series.slices.template.setAll({
            strokeOpacity: 0,
            templateField: "settings"
        });
        // 도넛 차트 분리 슬라이드 수정
        series.slices.template.states.create("active", {
            shiftRadius: 0 // 기본 반경 이동을 0으로 설정하여 비활성화
        });


        // Disable slice separation on click
        // series.slices.template.set("toggleKey", "");


        // Set data

        let data: DonutItem[] = await this.getDeptData();
        series.data.setAll(data);

        // Create legend
        let legend = chart.children.unshift(am5.Legend.new(donutRoot, {
            centerY: am5.percent(50),
            y: am5.percent(50),
            clickTarget: "none",
            layout: am5.GridLayout.new(donutRoot, {
                maxColumns: 1,
                fixedWidthGrid: true
            })
        }));

        // set width and max width of labels
        legend.labels.template.setAll({
            maxWidth: 180,
            width: 120,
            oversizedBehavior: "wrap",
            fill: am5.color(0x6A7075),
            fontSize: "14px",
        });
        legend.markers.template.setAll({
            width: 8,
            height: 8
        });
        legend.markerRectangles.template.setAll({
            cornerRadiusTL: 0,
            cornerRadiusTR: 0,
            cornerRadiusBL: 0,
            cornerRadiusBR: 0
        });

        legend.data.setAll(series.dataItems);

        // Play initial series animation
        series.appear(1000, 100);
    }


    async barGraphAnimated () {
        let data: NoShowItem[] = await this.getDeptNoShowData();

        // data의 길이만큼 noShowBars 배열을 0으로 초기화
        this.noShowBars = new Array(data.length).fill(0);
        this.noShowData = data;

        setTimeout(() => {
            this.noShowBars = data.map(item => parseFloat(item.percentile));
        }, 100);
    }

    // 요일별 차트 데이터 세팅
    async getWeekDayData():Promise<DataItem[]>{
        // API 호출 및 데이터 처리
        let weekdayList: meetingroom.meetingroomItemBase[] = await api.meetingroom.getConferenceRoomReserveStatsByWeekday(this.daysLineGraphDt,this.statParentCnfroomId)
            .then((res) => {return res;});

        let data: DataItem[] = weekdayList.map((item: meetingroom.meetingroomItemBase) => ({
            day: item.label,
            value: item.value
        }));
        this.daysTotCnt = this.formatNumber(data.reduce((sum, item) => sum + item.value, 0));


        return data;
    }
    formatNumber(value: number) {
        return value.toLocaleString();
    }
    removeDecimal(value: number) {
        return Math.floor(value);
    }

    // 기간별 차트 데이터 세팅
    async getPeriodData(range: string): Promise<RangeItem[]> {
        let Dt : string = "";
        switch (range) {
            case '7일':
                Dt = "7";
                break;
            case '15일':
                Dt = "15";
                break;
            case '한달':
                Dt = "30";
                break;
            case '1년':
                Dt = "365";
                break;
            default:
                Dt = "7";
                break;
        }
        // API 호출 및 데이터 처리
        let Period: meetingroom.meetingroomItemBase[] = await api.meetingroom.getConferenceRoomReserveStatsByPeriod(Dt,this.statParentCnfroomId)
            .then((res) => {return res;});

        let data : RangeItem[] = Period.map((item: meetingroom.meetingroomItemBase) => ({
            date: item.label,
            value: item.value
        }));

        return data;
    }
    // 본부별 차트 데이터
    async getDeptData():Promise<DonutItem[]>{
        let data : DonutItem[] = [];
        let donutColorList : object[] =[
            { fill: am5.color(0x005EFD) },
            { fill: am5.color(0x24C670) },
            { fill: am5.color(0xFFCC00) },
            { fill: am5.color(0xFF8000) },
            { fill: am5.color(0xEB464B) }
        ];

        // API 호출 및 데이터 처리
        let DonutList: meetingroom.meetingroomItemBase[] = await api.meetingroom.getConferenceRoomReserveStatsByDept(
            this.user.comCode, this.reserveDonutDt,5,this.statParentCnfroomId)
            .then((res) => {return res;});

        data = DonutList.map((item: meetingroom.meetingroomItemBase,index: number) => ({
            category: item.label,
            value: item.value,
            percentile : item.percentile,
            settings : donutColorList[index]
        }));
        this.deptTotCnt = this.formatNumber(data.reduce((sum, item) => sum + item.value, 0));

        return data;
    }
    // 본부별 노쇼 차트 데이터
    async getDeptNoShowData():Promise<meetingroom.meetingroomItemBase[]>{
        let data : NoShowItem[] = [];

        let NoShowList: meetingroom.meetingroomItemBase[] = await api.meetingroom.getConferenceRoomReserveStatsByNoShow(
            this.user.comCode, this.barGraphAnimatedDt,5,this.statParentCnfroomId)
            .then((res) => {return res;});

        data = NoShowList.map((item: meetingroom.meetingroomItemBase,index: number) => ({
            label: item.label,
            value: item.value,
            noShowCnt : item.noShowCnt,
            percentile : item.percentile,
            valueStr : item.valueStr
        }));
        return data;
    }
    //부모  미팅룸 리스트 가져오기
    async getParentConferenceRoom(){
      this.parentMeetingroomList = await api.meetingroom.getParentConferenceRoom(
            this.user.comCode)
            .then((res) => {return res;});

      console.log("this.parentMeetingroomList",this.parentMeetingroomList)
    }
    meetingroomStatsDownloadExcel(){

        return axios({
            method: 'post'
            , url: invalidateUrl('/cm/api/meetingroom/excel/roomandperson')
            , responseType: 'arraybuffer'
            , data : {
                ComCode : this.user.comCode,
                StartDt :this.startDate,
                EndDt : this.endDate,
                ParentCnfroomId : this.parentCnfroomId,
            }
            }).then(function(response){
                console.log('response', response)
                const disposition = response.headers['content-disposition'];
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(disposition);
                var fileName = '';
                if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, '');
                    if (fileName) {
                        fileName = decodeURIComponent(fileName);
                    }
                }
                const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                //IE 경우
                if((window.navigator as any) && (window.navigator as any).msSaveOrOpenBlob){
                    (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
                }else{
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `${fileName}`;
                    link.click();
                    Vue.nextTick(() => link.remove());
                }
            })
        }


}